'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = AirOption;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _basketHelpers = require('helpers/basketHelpers');

var _emailStyleTools = require('helpers/emailStyleTools');

var _OptionHeader = require('components/TemplateComponents/common/OptionHeader');

var _OptionHeader2 = _interopRequireDefault(_OptionHeader);

var _Journeys = require('./Journeys.jsx');

var _Journeys2 = _interopRequireDefault(_Journeys);

var _Pricing = require('./Pricing.jsx');

var _Pricing2 = _interopRequireDefault(_Pricing);

var _Rules = require('components/TemplateComponents/common/Rules');

var _Rules2 = _interopRequireDefault(_Rules);

var _Disclaimer = require('components/common/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AirOption(_ref) {
  var components = _ref.components,
      option = _ref.option,
      optionNumber = _ref.optionNumber,
      timeFormat = _ref.timeFormat,
      t = _ref.t;

  var journeys = option.journeys;
  var journeyDurations = option.journeyHeaders;
  var optionPrice = option.optionPrice;
  var faresBreakDown = option.faresBreakDown;
  var rules = option.rules;
  var lastDateToPurchase = (0, _basketHelpers.getLastDateToPurchase)(option);
  var checkSelfTransfer = option.checkSelfTransfer;

  var selectedTimeFormat = timeFormat;
  var styleFlightOptionContainer = (0, _emailStyleTools.containerStyles)(components, 'FlightOptionContainer');
  var styleFlightOptionLabel = (0, _emailStyleTools.textStyles)(components, 'FlightOptionLabel');
  var styleFlightCommentContainer = (0, _emailStyleTools.containerStyles)(components, 'FlightCommentContainer');
  var styleFlightComment = (0, _emailStyleTools.textStyles)(components, 'FlightComment');
  var styleRulesText = (0, _emailStyleTools.textStyles)(components, 'FlightRules');
  var renderDisclaimer = function renderDisclaimer(optionPrice) {
    var text = (0, _basketHelpers.getDisclaimerText)(optionPrice);
    if (text) {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Disclaimer2.default, { padTen: _emailStyleTools.padTen,
            containerStyle: styleFlightCommentContainer,
            textStyle: styleFlightComment,
            text: text
          })
        )
      );
    } else {
      return '';
    }
  };

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'AirOption' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_OptionHeader2.default, {
            containerStyle: styleFlightOptionContainer,
            textStyle: styleFlightOptionLabel,
            text: t('common.option') + ' ' + optionNumber,
            lastDateToPurchase: lastDateToPurchase,
            t: t
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Journeys2.default, { journeys: journeys, journeyDurations: journeyDurations && journeyDurations.map(function (o) {
              return o.totalDuration;
            }), selectedTimeFormat: selectedTimeFormat })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Pricing2.default, { faresBreakDown: faresBreakDown, optionPrice: optionPrice })
        )
      ),
      renderDisclaimer(option.optionPrice),
      checkSelfTransfer && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.padTen },
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, _emailStyleTools.emphasisBlueText, { fontSize: '11px' }) },
            'On this flight, you may need to check in separately for each connecting flight. You may need to collect hold bags and check them in again for the next flight. You must pass through security and passport control during each connection and you will need a visa if your connection is in a country that requires one. In the event of a cancellation or delay, your onward journey may not be guaranteed. Ask for the policies before booking.'
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Rules2.default, { rules: rules, style: styleRulesText })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AirOption.jsx
// module id = 1467
// module chunks = 0